import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { useUserRegisterMutation, useUserOAuthLoginMutation } from '../../redux/slices/authSlice';

// Components
import RegisterForm from './RegisterForm';
import Meta from '../shared/Meta';

import styles from '../../../stylesheets/public/layouts/Register.module.postcss';

function CateringRegister() {
  const { auth } = useAuth();
  const history = useHistory();

  const [userRegister] = useUserRegisterMutation();
  const [userOAuthLogin] = useUserOAuthLoginMutation();

  const onFormSubmit = (data) => {
    userRegister(data).unwrap().then(() => {
      history.push('/catering/dashboard');
    });
  };

  const validateForm = (values) => {
    const { password, password_confirmation } = values;
    const errors = {};
    if (password_confirmation &&
        password_confirmation !== password) {
      errors.password_confirmation = 'Passwords must match';
    }
    return errors;
  };

  return (
    <div className={styles.CateringRegister + ' u-blockCenter u-limitWidth35 u-mb3 u-mt3'}>
      <Meta noindex />
      <div className='u-pr1 u-pl1'>
        <h1 className='u-textCenter'>Book a truck</h1>
        <p className='u-small u-mb2 u-textCenter'>Register below to get quotes for your upcoming event</p>
      </div>
      <div className='Box Box--white'>

        { auth.userRegisterFailed &&
          <div className={styles.FormMessages}>
            <span className='icon icon-warning' />
            <h4>
              {auth.message}
            </h4>
          </div>
        }

        <div className='u-mb1'>
          <RegisterForm
            validate={validateForm}
            onSubmit={onFormSubmit}
            initialValues={{
              catering_user: true
            }}
          />
        </div>
        <hr className={styles.OrRule} />
        <div className='u-mb1'>
          <div className='u-text-sm u-blockCenter u-textCenter u-mr3 u-ml3 u-mb1'>
            By clicking Sign Up with Facebook or Sign Up with Google, you agree to the <Link to='/terms-and-conditions'>Terms of Use</Link> and <Link to='/privacy-policy'>Privacy Policy</Link>.
          </div>
          <button
            type='button'
            className={'Button Button--outlined u-w100 ' + styles.Button__facebook}
            onClick={() => {
              userOAuthLogin({
                provider: 'facebook',
                params: {
                  needs_user_type: false,
                  catering_user: true
                }
              });
            }}
          >
            <img src='/static/images/icons/facebook-logo-secondary.png' alt='Facebook logo'/>
            <span>Continue with Facebook</span>
          </button>

          <button
            type='button'
            className={`Button Button--outlined u-w100 ${styles.Button__google} u-ml0 u-mt1`}
            onClick={() => {
              userOAuthLogin({
                provider: 'google',
                params: {
                  needs_user_type: false,
                  catering_user: true
                }
              });
            }}
          >
            <img src='/static/images/icons/google.svg' alt='Sign up with Google'/>
            <span>Sign up with Google</span>
          </button>

          <button
            type='button'
            className={'Button u-w100 u-mt1 ' + styles.Button__apple}
            onClick={() => {
              userOAuthLogin({
                provider: 'apple',
                params: {
                  needs_user_type: false,
                  catering_user: true
                }
              });
            }}
          >
            <img src='/static/images/appleid_button_signup.png' height='48' alt='Sign up with Apple'/>
          </button>
        </div>
      </div>
      <div className='u-mt2 u-textCenter'>
        <small>Already have an account? <Link to='/login'>Log in</Link>.</small>
      </div>
    </div>
  );
}

export default CateringRegister;
